<td-loader-spinner [active]="loading"></td-loader-spinner>
<div class="td-wrapper" [ngClass]="outerContainerClass" [ngStyle]="outerContainerStyle" *ngIf="!loading">
  <div [ngClass]="toolbarClass" [ngStyle]="toolbarStyle" *ngIf="showToolbar">
    <div class="td-toolbar-show-diff">
      <label class="td-checkbox-container">
        Only Show Lines with Differences ({{ diffsCount }})
        <input type="checkbox" id="showDiffs" [ngModel]="hideMatchingLines" (ngModelChange)="hideMatchingLinesChanged($event)" />
        <span class="checkmark"></span>
      </label>
    </div>
  </div>
  <div class="td-table-wrapper" [ngClass]="compareRowsClass" [ngStyle]="compareRowsStyle">
    <!-- Right line-by-line -->
    <div class="td-table-container line-by-line" id="td-left-compare-container" tdContainer cdkScrollable>
      <table class="td-table">
        <tbody>
          <tr *ngFor="let row of filteredTableRows; trackBy: trackTableRows">
            <td
              scope="row"
              class="fit-column line-number-col"
              [ngClass]="{ 'delete-row': row.leftContent?.prefix === '-', 'empty-row': !row.leftContent?.lineContent }"
            >
              {{ row.leftContent?.lineNumber !== -1 ? row.leftContent?.lineNumber : ' ' }}
            </td>
            <td
              class="fit-column prefix-col"
              [ngClass]="{ 'delete-row': row.leftContent?.prefix === '-', 'empty-row': !row.leftContent?.lineContent }"
            >
              <span>{{ row.leftContent?.prefix || ' ' }}</span>
            </td>
            <td
              class="content-col"
              [ngClass]="{ 'delete-row': row.leftContent?.prefix === '-', 'empty-row': !row.leftContent?.lineContent }"
              *ngIf="!row.hasDiffs"
            >
              <span [innerHTML]="row.leftContent?.lineContent | formatLine"></span>
            </td>
            <td
              class="content-col"
              [ngClass]="{ 'delete-row': row.leftContent?.prefix === '-', 'empty-row': !row.leftContent?.lineContent }"
              *ngIf="row.hasDiffs"
            >
              <span
                [innerHTML]="diff.content | formatLine"
                [ngClass]="{ highlight: diff.isDiff }"
                *ngFor="let diff of row.leftContent?.lineDiffs; trackBy: trackDiffs"
              ></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Left line-by-line -->
    <div class="td-table-container line-by-line" id="td-right-compare-container" tdContainer cdkScrollable>
      <table class="td-table">
        <tbody>
          <tr *ngFor="let row of filteredTableRows; trackBy: trackTableRows">
            <td
              scope="row"
              class="fit-column line-number-col"
              [ngClass]="{ 'insert-row': row.rightContent?.prefix === '+', 'empty-row': !row.rightContent?.lineContent }"
            >
              {{ row.rightContent?.lineNumber !== -1 ? row.rightContent?.lineNumber : ' ' }}
            </td>
            <td
              class="fit-column prefix-col"
              [ngClass]="{ 'insert-row': row.rightContent?.prefix === '+', 'empty-row': !row.rightContent?.lineContent }"
            >
              <span>{{ row.rightContent?.prefix || ' ' }}</span>
            </td>
            <td
              class="content-col"
              [ngClass]="{ 'insert-row': row.rightContent?.prefix === '+', 'empty-row': !row.rightContent?.lineContent }"
              *ngIf="!row.hasDiffs"
            >
              <span [innerHTML]="row.rightContent?.lineContent | formatLine"></span>
            </td>
            <td
              class="content-col"
              [ngClass]="{ 'insert-row': row.rightContent?.prefix === '+', 'empty-row': !row.rightContent?.lineContent }"
              *ngIf="row.hasDiffs"
            >
              <span
                [innerHTML]="diff.content | formatLine"
                [ngClass]="{ highlight: diff.isDiff }"
                *ngFor="let diff of row.rightContent?.lineDiffs; trackBy: trackDiffs"
              ></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
